import React from "react";
import { RouteComponentProps } from "react-router-dom";
import GenericErrorPage from "../../../ErrorPages/Components/GenericErrorPage";

type TParams = {
  id: string;
};

export const NotSubscribedToApp: React.FC<RouteComponentProps<TParams>> = props => {
  const myDescription: string = `You do not appear to be subscribed to the app with code "${props.match.params.id}"`;

  return (
    <GenericErrorPage
      src="https://http.cat/403"
      alt="Forbidden"
      heading="Not Subscribed!"
      description={myDescription}
    />
  );
};
